<template>
  <CardSection :loading="isSavableStateLoading"
    :error="majorError">
    <template #header>
      Manage Notification Services
    </template>

    <template #body>
      <div class="form-group row">
        <div class="form-group mr-2 mb-0 col-12 d-flex">
          <router-link :to="{ name: 'admin_integrations_email_notifications_new' }"
            class="btn btn-primary btn-sm ml-auto">
            Add New Notification Service
          </router-link>
        </div>
      </div>

      <PortalTable ref="notification_services_index" table-id="notification_services_index"
        :total-records="totalRecords"
        :page="pageNumber"
        :page-count="pageCount"
        :table-data="records"
        :loading="isSavableStateLoading"
        filter-display="row"
        :filter-values="filterValues"
        empty="No Notification Service found!"
        @on-sort="handleSortChange"
        @on-page="handlePageChange"
        @on-filter-change="onFilterChange">
        <template #columns>
          <Column field="name"
            header="Name"
            filter-field="name"
            :sortable="true"
            :show-filter-menu="false">
            <template #filter="{ filterModel = { value: null }, filterCallback }">
              <InputText v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search by Service name"
                @input="filterCallback()" />
            </template>
          </Column>
          <Column field="sms" header="SMS" style="min-width: 100px;">
            <template #body="slotProps">
              <font-awesome-icon v-if="slotProps.data.sms" :icon="['fas', 'fa-check']" />
            </template>              
          </Column>
          <Column field="robocall" header="Robocall" style="min-width: 100px;">
            <template #body="slotProps">
              <font-awesome-icon v-if="slotProps.data.robocall" :icon="['fas', 'fa-check']" />
            </template>              
          </Column>
          <Column header="Actions">
            <template #body="slotProps">
              <router-link :to="{ name: 'admin_integrations_email_notifications_edit', params: { id: slotProps.data.id } }"
                class="action btn btn-fill btn-outline-primary mx-2">
                Edit
              </router-link>
            </template>
          </Column>
        </template>
      </PortalTable>
    </template>
  </CardSection>
</template>
<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { useNotificationServiceStore } from '@/src/stores/notification-service';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import InputText from 'primevue/inputtext';
import { FilterMatchMode } from '@primevue/core/api';
import { paginationMixin } from "@/src/mixins/paginationMixin";
import { pageMixin } from "@/src/mixins/pageMixin";

export default {
  components: {
    CardSection,
    PortalTable,
    Column,
    InputText,
  },
  mixins: [ savableStateMixin, pageMixin, paginationMixin ],
  setup() {
    const notificationServiceStore = useNotificationServiceStore();
    return {
      notificationServiceStore
    }
  },
  data() {
    return {
      search_params: '',
      filterValues: {
        "name": { value: null, matchMode: FilterMatchMode.STARTS_WITH }
      }
    }
  },
  async mounted() {
    this.setSavableStateLoading();
    await this.getRowData();
  },
  methods: {
    async getRowData(reset = false) {
      this.setSavableStateProcessing();
      if (reset) this.pageNumber = 1;

       if (reset) this.pageNumber = 1;

      let params = {
        page: this.pageNumber,
        sort_by: this.currentSortField,
        sort_type: this.currentSortType,
      };

      params = { ...this.search_params, ...params };

      try {
        const response = await this.notificationServiceStore.loadServices(params)
        this.processPagyResponse(response);

        this.setSavableStateIdle();
      } catch(error) {
        this.handleMajorError(error);
      }
    },
    onFilterChange(event) {
      this.search_params = event;
      this.getRowData(true);
    },
  }
}
</script>
